<template>
	<div :class="[{ 'is-survey': isSurvey }, {'is-not-survey': !isSurvey}]">
		<div class="video-response">
			<div class="response" v-for="(r, i) in response" :key="i">
				<!-- <FlagRecord
					v-if="questionnaire[i] && questionnaire[i].problem && isSurvey && getUserType != 'observer'"
					:question="question"
					:event="questionnaire[i]"
					:patient="patient">
				</FlagRecord> -->
				<div class="date" v-if="response.length > 1">
					{{ formatDate(questionnaire[i].completed) }}
				</div>
				<div class="answer-wrapper">
					<VideoPartial
						:response="r" 
						:question="question">
					</VideoPartial>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import QuestionResponse from '.'
import { mapActions, mapGetters } from 'vuex'
import VideoPartial from './partialResponse/VideoPartial'

export default {
	name: 'video',

	extends: QuestionResponse,

	data() {
		return {
			// comment: '',
			// renderKey: 0,
			// flagLoading: false,
			// flagSavedText: this.response.map(_ => false),
			// showFlagDialog: this.response.map(_ => false)
		}
	},

	computed: {
		...mapGetters(['getUserType']),
		...mapGetters('user', ['getUser']),
		...mapGetters('auth', ['getUserId']),
		...mapGetters('provider', [ 'allPatientsChosen', 'getProviderNameById']),
	},

	components: {
		VideoPartial
	}
}
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>
